import React from "react";
import { Fab } from "@mui/material";
import { WhatsApp as WhatsAppIcon } from "@mui/icons-material";
import { getOperatorPhone } from "../../../../utils/action";

export const FabWhatsApp = () => {
  const handleFormSubmit = async () => {
    const response = await getOperatorPhone();
    window.open(`https://wa.me/${response.data.nomor_operator}`, "_blank");
  };
  return (
    <Fab
      color="success"
      style={{ position: "fixed", bottom: 25, right: 25 }}
      onClick={() => handleFormSubmit()}
    >
      <WhatsAppIcon />
    </Fab>
  );
};
